<template>
  <div class="container container_mobile">
    <div
      class="loader"
      v-if="!infoLoaded"
    >
    </div>
    <div
      class="grid grid_h-center grid_v-margins"
      v-else
    >
      <div class="grid__col grid__col_xl-20" v-if="starts.length">
        <div class="block block_wide">
          <div class="block__item block__intro">
            <div class="block__intro-item block__intro-item_md">
              <h2>{{ $t('races.title') }}</h2>
            </div>
            <div class="block__intro-item">
              <event-races
                :utcCurrentTime="utcCurrentTime"
                :scountInfo="scountInfo"
                :races="starts"
                :finished="finished"
                :event="event"
                :dynamicRacesById="dynamicRacesById"
                :group-by-day="!finished"
                :raceProps="{
                  showIsLive: isLive,
                }"
                @click:aboutOnline="() => {
                  $root.$modals['about-online-modal'].open();
                }"
              ></event-races>
            </div>
          </div>
          <div v-if="isBannerGift" class="block__item">
            <BannerInfo
              :title="$t('gift.title')"
              :imgUrl="themeImages['gift']"
              @close="closeBannerGift"
            >
              <span v-html="$t('gift.text')" />
            </BannerInfo>
          </div>
          <div class="block__item" v-if="!finished && event.hasCommission && event.commission">
            <div class="text-xs color-muted text-center" v-html="$t('event.slotCommission', [`${event.commission.toLocaleString($lang)}%`])"></div>
          </div>
        </div>
      </div>
      <div class="grid__col grid__col_xl-20" v-if="theme === 'rr' && !event.rot">
        <Banner
          :content="banner"
          :contentMobile="bannerMobile"
        ></Banner>
      </div>
      <div class="grid__col grid__col_xl-20" v-if="!finished && availableGoods.length">
        <div class="block block_wide">
          <div class="block__item block__intro">
            <div class="block__intro-item block__intro-item_md">
              <h2>{{ $t('goods.title') }}</h2>
            </div>
            <div class="block__intro-item">
              <event-races
                :utcCurrentTime="utcCurrentTime"
                :scountInfo="scountInfo"
                :races="availableGoods"
                :dynamicRacesById="dynamicRacesById"
                :finished="finished"
                type="other"
              ></event-races>
            </div>
          </div>
        </div>
      </div>
      <div class="grid__col grid__col_lg-14 grid__col_xl-12">
        <div class="grid grid_v-margins">
          <div class="grid__col">
            <event-about
              :event="event"
              :finished="finished"
            ></event-about>
          </div>
          <div class="grid__col" v-if="series.length">
            <div class="block block_wide">
              <div class="block__item block__intro">
                <div class="block__intro-item block__intro-item_md">
                  <h2>Событие входит в&nbsp;серию</h2>
                </div>
                <div class="block__intro-item block__intro-item_md">
                  <div class="grid grid_v-margins">
                    <div
                      class="grid__col"
                      v-for="item in series"
                      :key="item.id"
                    >
                      <router-link
                        class="event-series-card"
                        :to="`/series/${item.code || item.id}`"
                        :style="{
                          backgroundImage: `url(${getSeriesImage(item.headerBanner)})`,
                          backgroundPosition: !item.headerBanner && 'left 20% center',
                        }"
                      >
                        <div class="event-series-card__overlay"></div>
                        <h3 class="event-series-card__title">{{ item.title }}</h3>
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="grid__col grid__col_lg-10 grid__col_xl-8">
        <div class="grid grid_v-margins">
          <event-members
            class="grid__col"
            v-if="hasMembers && showMembers"
          ></event-members>
          <div class="grid__col" v-if="startingPack">
            <div class="block block_wide">
              <div class="block__item block__intro">
                <div class="block__intro-item block__intro-item_md">
                  <h2>{{ $t('startPack.title') }}</h2>
                </div>
                <div class="block__intro-item">
                  <div
                    class="text-content html-content start-pack"
                    v-html="startingPack"
                  >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid__col" v-if="showDocs">
            <div class="block block_wide">
              <div class="block__item block__intro">
                <div class="block__intro-item block__intro-item_md">
                  <h2>{{ $t('documents.title') }}</h2>
                </div>
                <div class="block__intro-item">
                  <ul class="list">
                    <li
                      v-for="item in docs"
                      :key="item.id"
                    >
                      <a
                        class="link link_primary"
                        :href="item.url"
                        target="_blank"
                        v-html="item.title"
                      >
                      </a>
                      <div class="text-sm color-muted">
                        {{ item.ext }}
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="grid__col">
            <div class="block block_wide">
              <div class="block__item block__intro">
                <div
                  class="block__intro-item text-center"
                  v-if="logos && logos.length"
                >
                  <div class="event-organizer-logos">
                    <component
                      class="event-organizer-logos__item"
                      v-for="item in logos"
                      :key="item.iu"
                      :is="item.lnk ? 'a' : 'div'"
                      :href="item.lnk"
                      :target="item.lnk && '_blank'"
                      :rel="item.lnk && 'noopener'"
                    >
                      <img
                        :src="item.iu.replace('-x-', '-x64')"
                        :srcset="item.iu.replace('-x-', '-x128') + ' 2x'"
                        :alt="item.alt"
                      >
                    </component>
                  </div>
                </div>
                <div
                  class="block__intro-item text-center"
                  v-else
                >
                  <b>{{ beneficiary.name }}</b>
                </div>
                <div
                  class="block__intro-item text-center"
                  v-if="associations && associations.length"
                >
                  <div class="event-association-logos">
                    <component
                      class="event-association-logos__item"
                      v-for="item in associations"
                      :key="item.iu"
                      :is="item.lnk ? 'a' : 'div'"
                      :href="item.lnk"
                      :target="item.lnk && '_blank'"
                      :rel="item.lnk && 'noopener'"
                    >
                      <img
                        :src="item.iu.replace('-x-', '-x64')"
                        :srcset="item.iu.replace('-x-', '-x128') + ' 2x'"
                        :alt="item.alt"
                      >
                    </component>
                  </div>
                </div>
                <div class="block__intro-item text-center">
                  <a
                    class="link link_light text-sm"
                    href="#"
                    target="_blank"
                    v-open-modal="{ name: 'beneficiary-props-modal' }"
                  >
                    {{ $t('beneficiary.info') }}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="grid__col">
            <ContactsBlock
              :content="contacts"
            ></ContactsBlock>
          </div>
        </div>
      </div>
    </div>
    <modal
      name="beneficiary-props-modal"
      align="center"
      ref="modal"
    >
      <div class="base-modal__heading base-modal__item">
        <h3 class="base-modal__title">{{ $t('beneficiary.info') }}</h3>
      </div>
      <div class="base-modal__body base-modal__item">
        <div id="beneficiaryProps" class="beneficiary-props">
          <div class="beneficiary-props__item" v-if="beneficiary.name">
            <div class="beneficiary-props__title">
              <b>{{ $t('beneficiary.name') }}</b>
            </div>
            <div class="beneficiary-props__text">
              {{ beneficiary.name }}
            </div>
          </div>
          <div class="beneficiary-props__item" v-if="beneficiary.inn">
            <div class="beneficiary-props__title">
              <b>{{ $t('beneficiary.inn') }}</b>
            </div>
            <div class="beneficiary-props__text">
              {{ beneficiary.inn }}
            </div>
          </div>
          <div class="beneficiary-props__item" v-if="beneficiary.ogrn && !hideOgrn">
            <div class="beneficiary-props__title">
              <b>{{ $t('beneficiary.ogrn') }}</b>
            </div>
            <div class="beneficiary-props__text">
              {{ beneficiary.ogrn }}
            </div>
          </div>
          <div class="beneficiary-props__item" v-if="beneficiary.address">
            <div class="beneficiary-props__title">
              <b>{{ $t('beneficiary.address') }}</b>
            </div>
            <div class="beneficiary-props__text">
              {{ beneficiary.address }}
            </div>
          </div>
        </div>
      </div>
      <div class="base-modal__body base-modal__item">
        <Button
          variant="secondary"
          size="lg"
          :text="$t('beneficiary.print')"
          @click="printBeneficiaryInfo"
        ></Button>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EventRaces from '@/components/EventRaces.vue';
import EventAbout from '@/components/EventAbout.vue';
import EventMembers from '@/components/EventMembers.vue';
import ContactsBlock from '@/components/ContactsBlock.vue';
import Modal from '@/components/Modal.vue';
import Banner from '@/components/Banner.vue';
import BannerInfo from '@/components/BannerInfo.vue';
import { filter, isEmpty, some } from 'lodash';
import getScountInfo from '@/services/getScountInfo';

export default {
  name: 'EventOverview',
  components: {
    EventRaces,
    EventAbout,
    EventMembers,
    ContactsBlock,
    Modal,
    Banner,
    BannerInfo,
  },
  props: {
    event: Object,
    races: Array,
    showStartList: Boolean,
    hasMembers: Boolean,
    finished: Boolean,
    isLive: Boolean,
    dynamicRacesById: Object,
  },
  data() {
    return {
      utcCurrentTime: this.getCurrentUtcTime(),
      updateIntervalUtcId: null,
      series: [],
      startingPack: null,
      beneficiary: {},
      docs: {},
      contacts: null,
      logos: null,
      associations: null,
      starts: [],
      availableGoods: [],
      banner: '<div class="ad-pic" data-base-url="https://pictures.rr-dev.ru/api/v1/729ad383-1a9b-49a9-a0bc-d408182eab78" data-device="desktop"></div>',
      bannerMobile: '<div class="ad-pic" data-base-url="https://pictures.rr-dev.ru/api/v1/729ad383-1a9b-49a9-a0bc-d408182eab78" data-device="mobile"></div>',
      isBannerGift: true,
    };
  },
  computed: {
    scountInfo() {
      if (!this.races || !this.event) return;

      return this.getScountInfo(this.races, this.event);
    },
    ...mapGetters('settings', ['theme', 'themeImages']),
    infoLoaded() {
      return !isEmpty(this.event);
    },
    showMembers() {
      if (!this.races) {
        return false;
      }
      return this.showStartList && !some(this.races, (o) => !o.sl);
    },
    showDocs() {
      return this.docs.length;
    },
    hideOgrn() {
      const themes = ['samarkand'];
      return themes.includes(this.theme);
    },
  },
  methods: {
    getCurrentUtcTime() {
      return new Date().toISOString().slice(0, -1);
    },
    getScountInfo,
    getFileExtension(url) {
      if (!url) {
        return null;
      }
      const p = url.split('.');
      if (!p.length) {
        return null;
      }
      const ext = p[p.length - 1];
      return ext[0].toUpperCase() + ext.slice(1).toLowerCase();
    },
    getFileLink(name) {
      return `/file/${name}/download`;
    },
    getSeriesImage(url) {
      if (!url) {
        return '/Content/images/championship/championship-background.jpg';
      }
      return url.replace('/-x-/', '/-x400/');
    },
    setData() {
      const { event } = this;

      if (!event) {
        return;
      }

      this.startingPack = event.StartingPackHtml;
      this.contacts = event.ContactsHtml;
      this.series = event.series || [];

      this.beneficiary = event.AlternateBeneficiaryId !== null
        ? {
          name: event.AlternateBeneficiaryName,
          inn: event.AlternateBeneficiaryInn,
          ogrn: event.AlternateBeneficiaryOgrn,
          address: event.AlternateBeneficiaryAddress,
        }
        : {
          name: event.BeneficiaryName,
          inn: event.BeneficiaryInn,
          ogrn: event.BeneficiaryOgrn,
          address: event.BeneficiaryAddress,
        };

      let docs = [
        {
          id: 'terms',
          title: this.$t('documents.termsFileCaption'),
          path: event.TermsFileCode
            && `${event.TermsFileCode}/${event.TermsFilePath}`,
        },
        {
          id: 'offer',
          title: this.$t('documents.offerFileCaption'),
          path: event.OrganizerOfferFileCode
            && `${event.OrganizerOfferFileCode}/${event.OrganizerOfferFilePath}`,
        },
        {
          id: 'national',
          title: this.$t('documents.nationalRaceCertificationCaption'),
          path: event.NationalRaceCertificationFileCode
            && `${event.NationalRaceCertificationFileCode}/${event.NationalRaceCertificationFilePath}`,
        },
        {
          id: 'international',
          title: this.$t('documents.internationalRaceCertificationCaption'),
          path: event.InternationalRaceCertificationFileCode
            && `${event.InternationalRaceCertificationFileCode}/${event.InternationalRaceCertificationFilePath}`,
        },
      ];

      docs = filter(docs, (o) => o.path);
      docs.forEach((doc, i) => {
        const url = this.getFileLink(doc.path);
        docs[i].url = url;
        docs[i].ext = this.getFileExtension(doc.path);
      });

      this.docs = docs;

      this.logos = filter(event.OrganisersLogo, (o) => o.iu);
      this.associations = filter(event.AssociationsLogo, (o) => o.iu);

      if (this.races) {
        for (let i = 0; i < this.races.length; i += 1) {
          const race = this.races[i];

          const dynamicRace = this.dynamicRacesById[race.id];

          const dynamicAvailable = dynamicRace && (!dynamicRace.DisableRegistration && dynamicRace.AvailableRegistrationsCount !== 0);

          const registrationAvailable = race.rs === 2 && dynamicAvailable;
          const availableFriendReg = race.ism ? !race.dfr : true;

          if (race.dc === 'other') {
            if (registrationAvailable && availableFriendReg) {
              this.availableGoods.push(race);
            }
          } else {
            this.starts.push(race);
          }
        }
      }
    },
    printBeneficiaryInfo() {
      const printWindow = window.open('', '', 'width=800,height=600');

      const styles = '<style>'
        + 'h1 {font-size: 24px; margin-bottom: 32px; margin-top: 32px;}'
        + '.beneficiary-props {font-size: 16px; line-height: 24px;}'
        + '.beneficiary-props__item {margin-bottom: 16px;}'
        + '</style>';

      const title = `<h1>${this.event.Title}<hr>${this.$t('beneficiary.info')}</h1>`;

      printWindow.document.write(styles + title + document.getElementById('beneficiaryProps').outerHTML);

      printWindow.document.close();
      setTimeout(() => {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
      }, 100);
    },
    closeBannerGift() {
      this.isBannerGift = false;
    },
  },
  watch: {
    infoLoaded: {
      handler(val) {
        if (!val) {
          return;
        }
        this.setData();
      },
      immediate: true,
    },
  },
  created() {
    const conditionsToHideBannerInfo = [
      this.theme === 'rzd',
    ];

    this.isBannerGift = !conditionsToHideBannerInfo.some(Boolean);
  },
  mounted() {
    this.updateIntervalUtcId = setInterval(() => {
      this.utcCurrentTime = this.getCurrentUtcTime();
    }, 10000);
  },
  unmounted() {
    clearInterval(this.updateIntervalUtcId);
  },
};
</script>

<style lang="scss">
  .event-socials {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: -8px;

    &__item {
      flex: 0 0 auto;
      margin-left: 8px;
    }
  }

  .beneficiary-props {
    text-align: left;

    &__item {
      margin-bottom: 24px;

      &:last-child {
        margin-bottom: 0;
      }

      @media (min-width: breakpoint(md)) {
        display: flex;
      }
    }

    &__title {
      flex: 0 0 auto;
      max-width: 100%;
      margin-bottom: 4px;

      @media (min-width: breakpoint(md)) {
        margin-right: 24px;
      }
    }

    &__text {
      flex: 1 1 100%;
    }
  }

  .event-organizer-logos {

    &__item {
      display: block;
      margin-bottom: 16px;

      img {
        height: 64px;
        object-fit: contain;
      }
    }
  }

  .event-association-logos {
    margin-bottom: -16px;

    &__item {
      display: inline-block;
      vertical-align: middle;
      margin: 0 8px 16px;

      img {
        height: 32px;
        object-fit: contain;
      }
    }
  }

  .event-series-card {
    display: flex;
    flex-direction: column;
    width: 100%;
    color: $color-white;
    padding: 16px 20px;
    min-height: 190px;
    border-radius: 4px;
    text-decoration: none;
    outline: none;
    background-size: cover;
    background-position: center;
    position: relative;
    overflow: hidden;

    @media (min-width: breakpoint(md)) {
      padding: 20px 24px;
      min-height: 144px;
    }

    @media (min-width: breakpoint(xl)) {
      min-height: 130px;
    }

    &__overlay {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 50%, rgba(0, 0, 0, 0.65) 50%), linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.25) 100%);
    }

    &__title {
      margin-top: auto;
      position: relative;
      z-index: 1;
    }
  }
</style>
